import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { SundrySummaryWorkDistributionReport } from './Pages';

export const SundrySummaryWorkDistributionRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={SundrySummaryWorkDistributionReport} />
    </Fragment>
)